import { Config } from '../../config/config';

export const getStaticAPIPath = (src: string) =>
  `${Config.get().connectionConfig.staticApiUrl}/${src}`;
